import { UserIcon } from '@/common/components/icons'
import { Logo } from '@/common'

export default function FinalizedReportDeclarantsBanner() {
  return (
    <div className="flex items-center rounded-md p-4 bg-background-main gap-4">
      <Logo className="w-24 shrink-0" />
      <p className="text-sm">
        Access Artem Declarants at{' '}
        <a
          href="https://declarant.artem.earth"
          className="text-blue-500 underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://declarant.artem.earth
        </a>{' '}
        for more verification, and insights into the quality of your emissions data.
      </p>
      <a
        className="shrink-0"
        href="https://declarant.artem.earth/signup"
        target="_blank"
        rel="noopener noreferrer"
      >
        <button className="bg-green-600 text-white text-xs font-semibold px-4 py-2 rounded-xs flex items-center gap-2">
          <UserIcon className="size-4" />
          Sign up
        </button>
      </a>
    </div>
  )
}
